import { render, staticRenderFns } from "./give-proudly-Dashboard.vue?vue&type=template&id=e9553058&scoped=true"
import script from "./give-proudly-Dashboard.vue?vue&type=script&lang=js"
export * from "./give-proudly-Dashboard.vue?vue&type=script&lang=js"
import style0 from "./give-proudly-Dashboard.vue?vue&type=style&index=0&id=e9553058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9553058",
  null
  
)

export default component.exports